import { SafePipe } from './directives/safe.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { HelpContentDirective } from './directives/help-content.directive';
import { RangeSlideDirective } from './directives/range.directive';
import { DraggableDirective } from './directives/draggable.directive';
import { HeroTitleComponent } from './components/hero-title/hero-title.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    declarations: [SafePipe, MaintenanceComponent, HelpContentDirective, RangeSlideDirective, DraggableDirective, HeroTitleComponent, HeroTitleComponent],
    imports: [CommonModule, FlexLayoutModule, DragDropModule, MatCheckboxModule],
    exports: [SafePipe, HelpContentDirective, RangeSlideDirective, DraggableDirective, HeroTitleComponent, FlexLayoutModule, DragDropModule, MatCheckboxModule],
})
export class SharedModule {}
